import React, { Fragment, Suspense, useMemo } from 'react'
import Grid from '@material-ui/core/Grid'
import injectStyles from 'react-jss'

import { GridItem } from 'Components/Page/StatsPageWrapper'

import { useChartsLogic, formatChartData } from './utils'
import Loader from './components/Loader'
import ChartHeader from './components/ChartHeader'

import styles from './styles'

const Chart = React.lazy(() =>
  import(/* webpackChunkName: 'highcharts' */ 'Components/Chart'),
)

const EvolutionOverTheTimeChart = ({
  classes,
  data,
  chartDataHash,
  chartWeeks,
  chartMetrics,
  currencySign,
}) => {
  const chartOptions = useMemo(
    () => ({
      chart: {
        type: 'column',
      },
      xAxis: {
        categories: data.coordinateX,
        allowDecimals: false,
      },
      tooltip: {
        formatter: function() {
          const data = formatChartData(
            chartDataHash[`${this.key}|${this.series.name}`],
            currencySign,
          )

          return `
          <span>City - ${this.key}</span>
          <br>
          <span>Week - ${this.series.name}</span>
          ${data
            .map(([key, value]) => `<br><span>${key} - ${value}</span>`)
            .join('')}`
        },
      },
    }),
    [data, chartDataHash],
  )

  const {
    options,
    metrics,
    weekFrom,
    weekTo,
    handleFormChange,
    form,
  } = useChartsLogic({
    chartOptions,
    data,
    chartWeeks,
    chartMetrics,
    isHideTimeRangeSelects: true,
  })

  return (
    <Fragment>
      <h1>Evolution per city chart</h1>
      <GridItem>
        <Suspense fallback={<Loader />}>
          <Grid container>
            <Grid item xs={12}>
              <ChartHeader
                isHideTimeRangeSelects
                form={form}
                classes={classes}
                handleFormChange={handleFormChange}
                metrics={metrics}
                weekFrom={weekFrom}
                weekTo={weekTo}
              />
            </Grid>
            <Grid item xs={12}>
              <Chart options={options} />
            </Grid>
          </Grid>
        </Suspense>
      </GridItem>
    </Fragment>
  )
}

export default injectStyles(styles)(EvolutionOverTheTimeChart)



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/HighchartsCharts/EvolutionPerCityChart.js